import { useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { FreeMode } from 'swiper/modules'
import { Swiper } from 'swiper/react'
import { EventContentType, EventDetailType } from '../../@types/home'
import { getEventDetail, getEvents } from '../../api/home'
import { getCategories } from '../../api/product'
import '../../css/Exhibition.css'
import { SwiperSlideItem } from '../../pages/Category'
import EventSortLayer from '../event/EventSortLayer'
import EventSortModal from '../event/EventSortModal'
import Hr8 from '../hr/Hr8'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductFilterCenterModal from '../product/ProductFilterCenterModal'
import ProductFilterModal from '../product/ProductFilterModal'
import ProductModal from '../product/ProductModal'
import { useCommonContext } from '../provider/CommonProvider'
import ProductItem from './ProductItem'
import ProductListItem from './ProductListItem'

const imgURL = '/images'

export default function FestivalEvent({ eventNo }: any) {
  const [item, setItem] = useState<EventDetailType>()
  const [eventItem, setEventItem] = useState<EventContentType[]>([])
  const [type, setType] = useState<string>('thumb')
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [isModal, setIsModal] = useState(false)
  const [isSort, setIsSort] = useState<boolean>(false)
  const [isFilter, setIsFilter] = useState<boolean>(false) //필터 팝업열기
  const [getMax, setGetMax] = useState<number>(1000000)
  const [getMin, setGetMin] = useState<number>(0)
  const [freeCheck, setFreeCheck] = useState<boolean>(false)
  const [filterApply, setFilterApply] = useState<boolean>(false)
  const [brandArray, setBrandArray] = useState<any>([])
  const [sortKeyword, setSortKeyword] = useState<string>('ADMIN_SETTING') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('추천순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isSortIcon, setIsSortIcon] = useState<boolean>(false)
  const [categoryArray, setCategoryArray] = useState<any>([])
  const [category, setCategory] = useState<any>([])
  const [selectCategory, setSelectCategory] = useState<any>()
  const [selectItem, setSelectItem] = useState<any>([])
  const [selectItems, setSelectItems] = useState<any>([]) // 아이템 정렬된것
  const [items, setItems] = useState([])
  const [thirdCategoryArray, setThirdCategoryArray] = useState<any>([])
  const [thirdCategory, setThirdCategory] = useState<any>([])
  const [selectThirdCategory, setSelectThirdCategory] = useState<any>()
  const [fourCategoryArray, setFourCategoryArray] = useState<any>([])
  const [fourCategory, setFourCategory] = useState<any>([])
  const [selectFourCategory, setSelectFourCategory] = useState<any>(null)

  const [isAll, setIsAll] = useState(true)
  const [allCategory, setAllCategory] = useState<any>(null) //카테고리 전체 데이터
  const [allCheck, setAllCheck] = useState<any>([])
  const [floatCategory, setFloatCategory] = useState<any>(null)
  const [thirdArray, setThirdArray] = useState<any>(null)
  const [fourArray, setFourArray] = useState<any>(null)
  const [selectCategoryAllData, setSelectCategoryAllData] = useState<any>({}) //선택한 카테고리 전체데이터
  const obsRef = useRef(null) //observer Element
  const params = useParams()

  const { setIsLottie } = useCommonContext()

  const btnSortRef = useRef<any>(null)
  const is_scroll = window.scrollY
  const [position, setPosition] = useState(window.scrollY)
  const [isTouchMoving, setIsTouchMoving] = useState(false)

  const categoryWrapRef = useRef<any>(null)
  const category4WrapRef = useRef<any>(null)
  const categoryFourSubMenuWrapRef = useRef<any>(null)

  // 기획전 이미지
  const exhibitionMainImgRef = useRef<HTMLImageElement>(null)

  const touchMove = () => {
    setIsTouchMoving(true)
  }

  const touchEnd = () => {
    setIsTouchMoving(false)
  }

  const handleScroll = () => {
    if (categoryWrapRef.current) {
      const rect = categoryWrapRef.current.getBoundingClientRect()
      // console.log('Div 위치:', rect.top);

      if (rect.top <= 0) {
        // categoryWrapRef.current.classList.add('fixed');
      }
    }
    setPosition(is_scroll)
  }

  useEffect(() => {
    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', handleScroll)

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [position])

  useEffect(() => {
    if (category4WrapRef.current !== null) {
      if (fourCategory.length !== 0) {
        category4WrapRef.current.style.borderBottom = 'none'
      } else {
        category4WrapRef.current.style.borderBottom = '1px solid var(--colGray3)'
      }
    }
  }, [category4WrapRef.current, fourCategory])

  useEffect(() => {
    const selectCat = Number(selectCategory)
    const eventNum = Number(eventNo)

    if (selectCat === eventNum) {
      setSelectCategoryAllData([])
      return
    }

    if (allCategory) {
      const matchedCategory = allCategory.flatCategories.find((el: any) => el.depth2CategoryNo === selectCat)

      if (matchedCategory) {
        setSelectCategoryAllData(matchedCategory)
      }
    }
  }, [selectCategory, allCategory])

  useEffect(() => {
    // @ts-ignore
    getEventDetail(eventNo, sortKeyword)
      .then((res) => {
        setItem(res.data)
        setIsLottie(false)
      })
      .catch((err) => console.log(err))
  }, [sortKeyword])

  useEffect(() => {
    const linkSwiperSlide = document.querySelectorAll('.category .swiper-slide a')
    linkSwiperSlide.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        setIsAll(false)
      })
    })
  }, [isAll])

  useEffect(() => {
    getEvents('')
      .then((res) => {
        const array: any = []
        const findIndexById = (id: any) => {
          return res.data.contents.findIndex((item: any) => Number(item.eventNo) === Number(id))
        }
        const idx = findIndexById(eventNo)
        const contentsArray: any = []
        res.data.contents.map((el: any) => {
          if (Number(el.eventNo) !== 43284) {
            contentsArray.push(el)
          }
        })

        if (Number(idx) === Number(contentsArray.length)) {
          setEventItem([contentsArray[idx - 2], contentsArray[idx - 3], contentsArray[idx - 4]])
        } else if (Number(idx) === Number(contentsArray.length - 1)) {
          setEventItem([contentsArray[idx], contentsArray[idx - 2], contentsArray[idx - 3]])
        } else if (idx !== 0) {
          if (idx < 2) {
            setEventItem([contentsArray[idx - 1], contentsArray[idx + 1], contentsArray[idx + 2]])
            return
          }
          setEventItem([contentsArray[idx - 2], contentsArray[idx - 1], contentsArray[idx + 1]])
        } else if (idx === 0) {
          setEventItem([contentsArray[idx + 1], contentsArray[idx + 2], contentsArray[idx + 3]])
        }
      })
      .catch((err) => console.log(err))
  }, [params])

  useEffect(() => {
    if (item && item.section) {
      const categoryArray = item.section.flatMap((el: any) =>
        el.products.flatMap((element: any) => element.displayCategoryNos.split('|'))
      )

      setCategoryArray(categoryArray)
    }
  }, [item])

  useEffect(() => {
    getCategories().then((res) => {
      setAllCategory(res.data)
    })
  }, [])

  useEffect(() => {
    if (allCategory && categoryArray) {
      const includesArray = allCategory.flatCategories.filter((category: any) =>
        Object.values(category).some((value) => categoryArray.includes(Number(value)))
      )

      setFloatCategory(includesArray)
    }
  }, [allCategory, categoryArray])

  useEffect(() => {
    if (floatCategory && categoryArray) {
      const twoDepthArray: any = []
      const thridDepthArray: any = []
      const fourDepthArray: any = []
      floatCategory.map((el: any) => {
        twoDepthArray.push(el.depth2CategoryNo)
        thridDepthArray.push(el.depth3CategoryNo)
        fourDepthArray.push(el.depth4CategoryNo)
      })
      //@ts-ignore

      const twoSet = [...new Set(twoDepthArray)]
      //@ts-ignore
      const thirdSet = [...new Set(thridDepthArray)]
      setThirdArray(thirdSet)
      //@ts-ignore
      const fourSet = [...new Set(fourDepthArray)]
      setFourArray(fourSet)

      const twoDepArray: any = []

      allCategory.multiLevelCategories.map((element: any) => {
        if (element.label !== '브랜드') {
          element.children.map((el: any) => {
            for (let i = 0; i < twoSet.length; i++) {
              if (el.categoryNo === twoSet[i]) {
                twoDepArray.push(el)
              }
            }
          })
          handleRemoveDuplicates(twoDepArray)
        }
      })
    }
  }, [floatCategory, categoryArray, allCategory])

  useEffect(() => {
    if (selectCategory) {
      if (selectCategory !== eventNo) {
        const select: any = items.filter((item: any) => {
          return item.categoryNo === selectCategory
        })
        // console.log(select);
        const array: any = []
        select[0]?.children.map((el: any) => {
          for (let i = 0; i < thirdArray.length; i++) {
            if (el.categoryNo === thirdArray[i]) {
              array.push(el)
            }
          }
        })
        setThirdCategory(array)
        setFourCategoryArray([array])
      } else {
        setThirdCategory([])
        setFourCategoryArray([])
      }
    }
  }, [selectCategory])

  useEffect(() => {
    if (selectCategory !== selectThirdCategory) {
      const select = thirdCategory.filter((item: any) => {
        return item.categoryNo === selectThirdCategory
      })

      if (select[0]?.children) {
        const array: any = []
        select[0]?.children?.map((el: any) => {
          for (let i = 0; i < fourArray.length; i++) {
            if (el.categoryNo === fourArray[i]) {
              array.push(el)
            }
          }
        })
        setFourCategory(array)
      }
    }
  }, [selectCategory, selectThirdCategory])

  useEffect(() => {
    setFourCategoryArray([])
  }, [selectCategory])

  useEffect(() => {
    if (category && selectCategory) {
      const selectedCategory = category.find((el: any) => el.categoryNo === selectCategory)

      if (selectedCategory && selectedCategory.children) {
        setThirdCategoryArray((prev: any) => [...prev, ...selectedCategory.children])
      }
    }
  }, [category, selectCategory])

  useEffect(() => {
    if (thirdCategory) {
      const uniqueCategories = new Set()

      thirdCategory.forEach((el: any) => {
        el.children.forEach((child: any) => {
          uniqueCategories.add(child) // 중복 제거를 위해 Set 사용
        })
      })

      setAllCheck(Array.from(uniqueCategories)) // Set을 배열로 변환
    }
  }, [thirdCategory])

  useEffect(() => {
    if (thirdCategoryArray) {
      const newChildren: any = []

      thirdCategoryArray.forEach((el: any) => {
        if (el.categoryNo === selectThirdCategory) {
          newChildren.push(...el.children) // 조건이 맞는 경우 자식 카테고리를 수집
        }
      })

      // 상태 업데이트
      setFourCategoryArray(newChildren)
    }
  }, [thirdCategoryArray, selectThirdCategory])

  useEffect(() => {
    if (fourCategoryArray) {
      const unique = removeDuplicatesByCategoryNo(fourCategoryArray)
      setFourCategory(unique)
    }
  }, [fourCategoryArray])

  useEffect(() => {
    if (thirdCategoryArray) {
      const unique = removeDuplicatesByCategoryNo(thirdCategoryArray)
      setThirdCategory(unique)
    }
  }, [thirdCategoryArray])

  const removeDuplicatesByCategoryNo = (arr: any) => {
    const seen = new Set()
    return arr.filter((item: any) => {
      const duplicate = seen.has(item.categoryNo)
      seen.add(item.categoryNo)
      return !duplicate
    })
  }

  const handleRemoveDuplicates = (item: any) => {
    const uniqueItems = removeDuplicatesByCategoryNo(item)
    setItems(uniqueItems)
  }

  useEffect(() => {
    if (category) {
      category.sort(function (a: any, b: any) {
        return a.categoryNo - b.categoryNo
      })
      handleRemoveDuplicates(category)
      // setItems(category);
      if (!selectCategory) {
        setSelectCategory(eventNo)
      }
    }
  }, [category])

  useEffect(() => {
    if (selectItem) {
      const array = [...selectItem]
      const removeArray = removeDuplicates(array, 'productNo')

      setSelectItems(removeArray)
    }
  }, [sortKeyword, selectItem])

  function removeDuplicates(array: any, key: any) {
    const map = new Map()
    array.forEach((item: any) => {
      map.set(item[key], item)
    })
    return Array.from(map.values())
  }

  useEffect(() => {
    if (selectCategory && item?.section) {
      if (selectCategory === eventNo) {
        setSelectItem(item?.section[0]?.products)
      }
    }
  }, [items, selectCategory])

  useEffect(() => {
    if (selectThirdCategory) {
      if (selectFourCategory) {
        if (thirdCategory) {
          if (thirdCategory[0]?.children.length !== 0) {
            if (Number(selectThirdCategory) === Number(selectFourCategory)) {
              const array: any = []
              fourCategory.map((element: any) => {
                item?.section[0].products.map((el: any) => {
                  if (el.displayCategoryNos.includes(element.categoryNo)) {
                    array.push(el)
                  }
                  setSelectItem(array)
                })
              })
            } else {
              const array: any = []
              item?.section[0].products.map((el: any) => {
                if (el.displayCategoryNos.includes(selectFourCategory)) {
                  array.push(el)
                }
                setSelectItem(array)
              })
            }
          } else if (Number(selectCategory) === Number(selectThirdCategory)) {
            if (thirdCategory[0]?.children?.length !== 0) {
              const array: any = []
              thirdCategory.map((elem: any) => {
                elem?.children.map((els: any) => {
                  item?.section[0].products.map((element: any) => {
                    if (element.displayCategoryNos.includes(els.categoryNo)) {
                      array.push(element)
                    }
                    setSelectItem(array)
                  })
                })
              })
            }

            if (thirdCategory.length === 0) {
              const array: any = []
              item?.section[0].products.map((element: any) => {
                if (element.displayCategoryNos.includes(selectThirdCategory)) {
                  array.push(element)
                }
                setSelectItem(array)
              })
            }
          } else {
            if (Number(selectCategory) !== Number(eventNo)) {
              const array: any = []
              item?.section[0].products.map((el: any) => {
                if (el.displayCategoryNos.includes(selectThirdCategory)) {
                  array.push(el)
                }
                setSelectItem(array)
              })
            }
          }
        }
      } else {
        if (Number(selectCategory) !== Number(eventNo)) {
          if (Number(selectCategory) === Number(selectThirdCategory)) {
            const array: any = []
            if (thirdCategory.length === 0) {
              item?.section[0].products.map((element: any) => {
                if (element.displayCategoryNos.includes(selectCategory)) {
                  array.push(element)
                }
                setSelectItem(array)
              })
            } else if (thirdCategory[0]?.children?.length !== 0) {
              const array: any = []
              allCheck?.map((elem: any) => {
                item?.section[0].products.map((element: any) => {
                  if (element.displayCategoryNos.includes(elem.categoryNo)) {
                    array.push(element)
                  }

                  setSelectItem(array)
                })
              })
            } else {
              thirdCategory.map((elem: any) => {
                item?.section[0].products.map((element: any) => {
                  if (element.displayCategoryNos.includes(elem.categoryNo)) {
                    array.push(element)
                  }

                  setSelectItem(array)
                })
              })
            }
          }
        }
      }
    }
  }, [selectCategory, selectThirdCategory, selectFourCategory, thirdCategory, fourCategory, allCheck])

  return (
    <>
      <div className='exhibition_detail_cont'>
        {/* {item.top?.length === 0 ? null : (
            // 기획전 이미지
            <div className='visual_img' ref={exhibitionMainImgRef}>
              <img src={`${isMobile ? item?.top?.mobile?.url : item?.top?.pc?.url}`} alt='' width='100%' />
            </div>
          )} */}
        {item?.eventYn === 'Y' ? null : (
          <>
            {' '}
            <CategoryWrap className='category_wrap' isAll={isAll} ref={categoryWrapRef}>
              <div className='category'>
                <div className='inner'>
                  <SwiperWrap
                    slidesPerView={'auto'}
                    spaceBetween={12}
                    breakpoints={{
                      768: {
                        spaceBetween: 20,
                      },
                    }}
                    modules={[FreeMode]}
                    freeMode={true}
                    centeredSlidesBounds={true}
                    slideToClickedSlide={true}
                    onTouchMove={touchMove}
                    onTouchEnd={touchEnd}
                  >
                    <SwiperSlideItem>
                      <div className={eventNo === selectCategory ? 'on' : ' '}>
                        <a
                          className='all'
                          href='#'
                          onTouchEnd={(e) => {
                            if (isMobile && !isTouchMoving) {
                              e.preventDefault()
                              setSelectCategory(eventNo)
                              setSelectFourCategory(null)
                              setFourCategory([])
                              setIsAll(true)
                            }
                          }}
                          onClick={(e) => {
                            if (!isMobile) {
                              e.preventDefault()
                              setSelectCategory(eventNo)
                              setSelectFourCategory(null)
                              setFourCategory([])
                              setIsAll(true)
                            }
                          }}
                        >
                          전체
                        </a>
                      </div>
                    </SwiperSlideItem>
                    {items.map((el: any) => {
                      return (
                        <SwiperSlideItem key={el.categoryNo}>
                          <SliceItemTwo
                            el={el}
                            setIsAll={setIsAll}
                            imageHeight={exhibitionMainImgRef.current?.offsetHeight}
                            setSelectThirdCategory={setSelectThirdCategory}
                            setSelectCategory={setSelectCategory}
                            setSelectFourCategory={setSelectFourCategory}
                            selectCategory={selectCategory}
                            setFourCategory={setFourCategory}
                            isTouchMoving={isTouchMoving}
                          ></SliceItemTwo>
                        </SwiperSlideItem>
                      )
                    })}
                  </SwiperWrap>
                </div>
              </div>
            </CategoryWrap>
            {thirdCategory.length !== 0 ? (
              <Category4Wrap ref={category4WrapRef} className='exhibition_category_header4' isAll={isAll}>
                <div className='category4'>
                  <div className='inner'>
                    <SwiperWrap
                      slidesPerView={'auto'}
                      spaceBetween={12}
                      breakpoints={{
                        768: {
                          spaceBetween: 20,
                        },
                      }}
                      modules={[FreeMode]}
                      freeMode={true}
                      centeredSlidesBounds={true}
                      slideToClickedSlide={true}
                      onTouchMove={touchMove}
                      onTouchEnd={touchEnd}
                    >
                      <SwiperSlideItem>
                        <div className={selectThirdCategory === selectCategory ? 'on' : ' '}>
                          <a
                            className='all'
                            href='#'
                            onTouchEnd={(e) => {
                              if (isMobile && !isTouchMoving) {
                                e.preventDefault()
                                setSelectThirdCategory(selectCategory)
                                setSelectFourCategory(null)
                                setFourCategory([])
                              }
                            }}
                            onClick={(e) => {
                              if (!isMobile) {
                                e.preventDefault()
                                setSelectThirdCategory(selectCategory)
                                setSelectFourCategory(null)
                                setFourCategory([])
                              }
                            }}
                          >
                            전체
                          </a>
                        </div>
                      </SwiperSlideItem>
                      {thirdCategory.map((el: any) => {
                        return (
                          <SwiperSlideItem key={el.categoryNo}>
                            <SliceItemThird
                              el={el}
                              setSelectCategory={setSelectThirdCategory}
                              selectCategory={selectThirdCategory}
                              setSelectFourCategory={setSelectFourCategory}
                              imageHeight={exhibitionMainImgRef.current?.offsetHeight}
                              isTouchMoving={isTouchMoving}
                            ></SliceItemThird>
                          </SwiperSlideItem>
                        )
                      })}
                    </SwiperWrap>
                  </div>
                </div>
              </Category4Wrap>
            ) : null}
            {fourCategory.length !== 0 ? (
              <CategoryFourSubMenuWrap
                ref={categoryFourSubMenuWrapRef}
                className='exhibition_category_header_four_submenu'
              >
                <div className='category_four_submenu'>
                  <div className='inner'>
                    <SwiperWrap
                      slidesPerView={'auto'}
                      spaceBetween={12}
                      breakpoints={{
                        768: {
                          spaceBetween: 20,
                        },
                      }}
                      modules={[FreeMode]}
                      freeMode={true}
                      centeredSlidesBounds={true}
                      slideToClickedSlide={true}
                      onTouchMove={touchMove}
                      onTouchEnd={touchEnd}
                    >
                      <SwiperSlideItem>
                        <div className={selectThirdCategory === selectFourCategory ? 'on' : ' '}>
                          <a
                            className='all'
                            href='#'
                            onTouchEnd={(e) => {
                              if (isMobile && !isTouchMoving) {
                                e.preventDefault()
                                setSelectFourCategory(selectThirdCategory)
                              }
                            }}
                            onClick={(e) => {
                              if (!isMobile) {
                                e.preventDefault()
                                setSelectFourCategory(selectThirdCategory)
                              }
                            }}
                          >
                            전체
                          </a>
                        </div>
                      </SwiperSlideItem>
                      {fourCategory.map((el: any) => {
                        return (
                          <SwiperSlideItem key={el.categoryNo}>
                            <SliceItem
                              el={el}
                              setSelectCategory={setSelectFourCategory}
                              selectCategory={selectFourCategory}
                              imageHeight={exhibitionMainImgRef.current?.offsetHeight}
                              isTouchMoving={isTouchMoving}
                            ></SliceItem>
                          </SwiperSlideItem>
                        )
                      })}
                    </SwiperWrap>
                  </div>
                </div>
              </CategoryFourSubMenuWrap>
            ) : null}
          </>
        )}
        {/* 상품 목록 불러와서 사용해야 할 영역 */}
        <div className='product_list_wrap product'>
          {item?.eventYn === 'Y' ? null : (
            <div className='item_list'>
              <div className='product_list_header'>
                <div className='product_list_num'>
                  <span>{selectItems?.length}</span>개의 상품
                </div>

                <ul className='product_list_option'>
                  <li>
                    <button
                      ref={btnSortRef}
                      className='btn_sort'
                      onClick={() => {
                        setIsSort((prev: boolean) => !prev)
                        // if (setIsSort) {
                        //   setIsSort(true);
                        // }
                        setIsSortIcon(!isSortIcon)
                      }}
                    >
                      {sortKeywordLabel ? sortKeywordLabel : '정렬'}
                      {!isMobile && isSortIcon ? (
                        <img src={`${imgURL}/icon_arrow_up.png`} alt='' />
                      ) : (
                        <img src={`${imgURL}/icon_arrow_down.png`} alt='' />
                      )}
                    </button>
                    {isSort ? (
                      isMobile ? (
                        <EventSortModal
                          headerText='정렬'
                          setIsModal={setIsSort}
                          setSortKeyword={setSortKeyword}
                          sortKeyword={sortKeyword}
                          setSortKeywordLabel={setSortKeywordLabel}
                          setSortDirection={setSortDirection}
                          sortDirection={sortDirection}
                        ></EventSortModal>
                      ) : (
                        <EventSortLayer
                          setIsModal={setIsSort}
                          setSortKeyword={setSortKeyword}
                          sortKeyword={sortKeyword}
                          setSortKeywordLabel={setSortKeywordLabel}
                          setSortDirection={setSortDirection}
                          sortDirection={sortDirection}
                          setIsSortIcon={setIsSortIcon}
                          btnSortRef={btnSortRef}
                        ></EventSortLayer>
                      )
                    ) : null}
                  </li>

                  <li>
                    <button className='btn_listtype'>
                      <img
                        onClick={() => {
                          if (type === 'thumb') {
                            setType('list')
                          } else {
                            setType('thumb')
                          }
                        }}
                        src={`${type === 'thumb' ? `${imgURL}/icon_list.png` : `${imgURL}/icon_list_thumb.png`}`}
                        alt='상품보기 썸네일형'
                      />
                    </button>
                  </li>
                </ul>
              </div>

              <div className={type === 'thumb' ? 'product_wrap' : 'product_wrap list'}>
                {type === 'thumb' &&
                  selectItems?.map((el: any, idx: number) => {
                    return (
                      <ProductItem
                        item={el}
                        key={idx}
                        setIsModal={setIsModal}
                        idx={idx}
                        setSelectProductNo={setSelectProductNo}
                        totalCount={selectItems?.length}
                        categoryData={selectCategoryAllData}
                      />
                    )
                  })}
                {type === 'list' &&
                  selectItems?.map((el: any, idx: number) => {
                    return (
                      <ProductListItem
                        item={el}
                        idx={idx}
                        key={idx}
                        setIsModal={setIsModal}
                        setSelectProductNo={setSelectProductNo}
                        listItem={el}
                      />
                    )
                  })}
              </div>
            </div>
          )}
          <div ref={obsRef}></div>
          {/* <div ref={obsRef} style={{ height: "10px" }}></div> */}
          {isMobile ? <Hr8></Hr8> : null}

          {/* 상품 목록 불러와서 사용해야 할 영역 */}
        </div>
      </div>

      {isModal ? (
        isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={selectItems}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={selectItems}
          ></ProductCenterModal>
        )
      ) : null}
      {isFilter ? (
        isMobile ? (
          <ProductFilterModal
            isCategoryModal={isFilter}
            setIsCategoryModal={setIsFilter}
            setFreeCheck={setFreeCheck}
            setGetMax={setGetMax}
            setGetMin={setGetMin}
            setFilterApply={setFilterApply}
            setBrandArray={setBrandArray}
            brandArray={brandArray}
          ></ProductFilterModal>
        ) : (
          <ProductFilterCenterModal
            isCategoryModal={isFilter}
            setIsCategoryModal={setIsFilter}
            setFreeCheck={setFreeCheck}
            setGetMax={setGetMax}
            setGetMin={setGetMin}
            setFilterApply={setFilterApply}
            setBrandArray={setBrandArray}
            brandArray={brandArray}
          ></ProductFilterCenterModal>
        )
      ) : null}
    </>
  )
}

function SliceItem({ el, setSelectCategory, selectCategory, imageHeight, isTouchMoving }: any) {
  const navigate = useNavigate()
  return (
    <div className={el.categoryNo === selectCategory ? 'on' : ' '}>
      <a
        href='#'
        onTouchEnd={(e) => {
          if (isMobile && !isTouchMoving) {
            e.preventDefault()
            // alert(el?.categoryNo);
            setSelectCategory(el?.categoryNo)
          }
        }}
        onClick={(e) => {
          if (!isMobile) {
            e.preventDefault()
            setSelectCategory(el?.categoryNo)
          }
        }}
        key={el?.categoryNo}
      >
        {el.label}
      </a>
    </div>
  )
}

function SliceItemThird({
  el,
  setSelectCategory,
  selectCategory,
  imageHeight,
  setSelectFourCategory,
  isTouchMoving,
}: any) {
  return (
    <div className={el.categoryNo === selectCategory ? 'on' : ' '}>
      <a
        href='#'
        onTouchEnd={(e) => {
          if (isMobile && !isTouchMoving) {
            e.preventDefault()
            setSelectCategory(el?.categoryNo)
            setSelectFourCategory(el?.categoryNo)
          }
        }}
        onClick={(e) => {
          if (!isMobile) {
            e.preventDefault()
            setSelectCategory(el?.categoryNo)
            setSelectFourCategory(el?.categoryNo)
          }
        }}
        key={el?.categoryNo}
      >
        {el.label}
      </a>
    </div>
  )
}

function SliceItemTwo({
  el,
  setSelectCategory,
  selectCategory,
  setSelectThirdCategory,
  setFourCategory,
  setIsAll,
  imageHeight,
  setSelectFourCategory,
  setIsMiddle,
  isTouchMoving,
}: any) {
  return (
    <div className={el.categoryNo === selectCategory ? 'on' : ' '}>
      <a
        href='#'
        onTouchEnd={(e) => {
          if (isMobile && !isTouchMoving) {
            e.preventDefault()
            setSelectCategory(el?.categoryNo)
            setSelectThirdCategory(el?.categoryNo)
            setSelectFourCategory(null)
            setFourCategory([])
            setIsAll(false)
          }
        }}
        onClick={(e) => {
          if (!isMobile) {
            e.preventDefault()
            setSelectCategory(el?.categoryNo)
            setSelectThirdCategory(el?.categoryNo)
            setSelectFourCategory(null)
            setFourCategory([])
            setIsAll(false)
          }
        }}
        key={el?.categoryNo}
      >
        {el.label}
      </a>
    </div>
  )
}
interface CategoryWrapProps {
  isAll: boolean
}

const forwardAllProp = (prop: string) => prop !== 'isAll'

export const CategoryWrap = styled.div.withConfig({
  shouldForwardProp: forwardAllProp,
})<CategoryWrapProps>`
  /* 모바일: 3depth 카테고리 영역 */
  padding: 4px 0 0 0;
  border-bottom: ${({ isAll }) => (isAll ? '1px var(--colGray3) solid' : 'none')};
  & .swiper {
    position: relative;
    top: 2px;
    padding: 0 20px;
  }

  &.fixed {
    /* padding-bottom: 48px; */
    & .swiper {
      position: fixed;
      top: 48px;
      left: 0;
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${({ isAll }) => (isAll ? 'var(--colGray3)' : 'transparent')};
        z-index: -1;
      }
    }
  }
  & div.category {
    position: relative;
    width: 100%;
    padding: 0;
    top: 1px;
  }

  @media screen and (min-width: 768px) {
    padding: 4px 0 0 0;
    border-bottom: none;
    border-bottom: ${({ isAll }) => (isAll ? '1px solid var(--colGray3)' : 'none')};

    & .inner {
      /* border-bottom: ${({ isAll }) => (isAll ? '1px solid var(--colGray3)' : 'none')}; */
      border: none;
      background: none;
      padding: 0 32px;
    }

    & .swiper {
      position: relative;
      top: 0;
      padding: 0;

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${({ isAll }) => (isAll ? 'var(--colGray3)' : 'none')};
        z-index: -1;
        display: none;
      }
    }
    &.fixed {
      position: fixed;
      top: 84px;
      left: 0;
      height: 50px;
      width: 100%;
      padding: 0;
      border-bottom: ${({ isAll }) => (isAll ? '1px solid var(--colGray3)' : 'none')};
      z-index: 99;
      & .inner {
        width: 100%;
        height: 50px;
        z-index: 30;
      }
      & .swiper {
        position: relative;
        top: -1px;
        background: none;
        width: 1216px;
        margin: 0 auto;
        z-index: 10;
        padding: 0;
      }
    }
  }
  & div.category {
    position: relative;
    width: 100%;
    height: 50px;
    background: none;
    padding: 0;
    border-bottom: 1px solid var(--colgray3);
    & div.category::after {
      width: 100%;
      display: block;
      height: 1px;
      position: absolute;
      bottom: 0px;
    }
  }
`

export const SwiperWrap = styled(Swiper)`
  overflow: hidden;
  z-index: 1;
  padding: 0 20px;

  & div.swiper-wrapper {
    & div.swiper-slide {
      width: auto !important;
      position: relative;
      & a {
        display: block;
        padding: 15px 2px;
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        color: #a3a3a3;
      }
    }
    & div.on {
      & ::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: var(--colBlack);
        left: 0;
      }
      a {
        color: var(--colBlack);
        font-weight: 700;
      }
    }
  }
  @media screen and (min-width: 768px) {
    overflow: hidden;
    z-index: 1;
    padding: 0;
    width: 1216px;
    margin: 0 auto;

    & div.swiper-wrapper {
      & div.swiper-slide {
        width: auto !important;
        position: relative;
        & a {
          display: block;
          padding: 16px 2px;
          font-size: 16px;
          font-weight: 500;
          line-height: 18px;
          color: #a3a3a3;
        }
      }
      & div.on {
        & ::after {
          content: '';
          display: block;
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 2px;
          background: var(--colBlack);
          left: 0;
        }
        a {
          color: var(--colBlack);
          font-weight: 700;
        }
      }
    }
  }
`

interface Category4WrapProps {
  isAll: boolean
}

// Category4
export const Category4Wrap = styled.div<Category4WrapProps>`
  width: 100%;
  height: 48px;
  background: var(--colWhite);
  border-bottom: ${({ isAll }) => (isAll ? '1px solid var(--colGray3)' : 'none')};
  &.fixed {
    padding-bottom: 48px;

    & .swiper {
      position: fixed;
      top: 96px;
      left: 0;
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      border-bottom: 1px solid var(--colGray3);
    }
  }
  & div.category4 {
    padding: 0;
    & .inner {
      border-bottom: none;
    }
    & .swiper {
      & .swiper-slide div a {
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        color: var(--colGray5);
      }
      & .swiper-slide div.on a {
        color: var(--colBlack);
      }
    }
  }
  &.exhibition_category_header4 .swiper {
    /* padding: 0; */
  }

  /* 기획전 PC Category4 */
  @media screen and (min-width: 768px) {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid var(--colGray3);
    &.fixed {
      position: fixed;
      top: 132px;
      left: 0;
      width: 100%;
      height: 50px;
      padding-bottom: 0;
      border-bottom: 1px solid var(--colGray3);
      z-index: 20;
      & .swiper {
        position: relative;
        top: 1px;
        width: 1216px;
        margin: 0 auto;
        background: none;
        z-index: 10;
        padding: 0;
        border-bottom: none;
      }
    }
    & div.category4 {
      padding: 0;
      /* border-bottom: 1px solid var(--colGray3); */
      & .inner {
        width: 1216px;
        margin: 0 auto; // PC 4뎁스 swiper 가운데 정렬
        border-bottom: none;
      }
      & .swiper {
        width: 1216px;
        margin: 0 auto;
        & .swiper-slide div a {
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          color: var(--colGray5);
        }
        & .swiper-slide div.on a {
          color: var(--colBlack);
        }
      }
    }
    &.exhibition_category_header4 .swiper {
      /* padding: 0; */
    }
  }
`

// Category Four Submenu
export const CategoryFourSubMenuWrap = styled.div`
  width: 100%;
  height: 48px;
  background: var(--colWhite);
  border-bottom: 1px solid var(--colGray3);

  &.fixed {
    position: fixed;
    top: 144px;
    left: 0;
    width: 100%;
    z-index: 20;
    & .swiper {
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;
      border-bottom: 1px solid var(--colGray3);
    }
  }
  & div.category_four_submenu {
    padding: 0;
    & .inner {
      border-bottom: none;
    }
    & .swiper {
      & .swiper-slide div a {
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
        color: var(--colGray5);
      }
      & .swiper-slide div.on a {
        color: var(--colBlack);
      }
      & .swiper-slide div.on a::after {
        display: none;
      }
    }
  }
  &.exhibition_category_header_four_submenu .swiper {
    /* padding: 0; */
  }

  /* 기획전 PC CategoryFourSubMenu */
  @media screen and (min-width: 768px) {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid var(--colGray3);
    &.fixed {
      position: fixed;
      top: 181px;
      width: 100%;
      height: 50px;
      padding-bottom: 0;
      border-bottom: 1px solid var(--colGray3);
      z-index: 10;
      & .swiper {
        position: relative;
        top: 1px;
        width: 1216px;
        margin: 0 auto;
        background: none;
        z-index: 10;
        padding: 0;
        border-bottom: none;
      }
    }
    & div.category_four_submenu {
      padding: 0;
      /* border-bottom: 1px solid var(--colGray3); */
      & .inner {
        width: 1216px;
        margin: 0 auto; // PC 4뎁스 swiper 가운데 정렬
        border-bottom: none;
      }
      & .swiper {
        width: 1216px;
        margin: 0 auto;
        & .swiper-slide div a {
          font-size: 16px;
          font-weight: 400;
          line-height: 18px;
          color: var(--colGray5);
        }
        & .swiper-slide div.on a {
          color: var(--colBlack);
        }
      }
    }
    &.exhibition_category_header_four_submenu .swiper {
      /* padding: 0; */
    }
  }
`
